import MixpanelBrowser, { Dict } from 'mixpanel-browser';

const token = import.meta.env.VITE_MIXPANEL_TOKEN;
const MP_FORCE = JSON.parse(window.localStorage.getItem('MIXPANEL_FORCE') ?? 'false');
const mixpanel =
  MP_FORCE || import.meta.env.VITE_APP_ENVIRONMENT === 'production'
    ? // eslint-disable-next-line import/no-named-as-default-member
      MixpanelBrowser.init(token ?? '', {}, 'MixpanelService')
    : {
        identify: (id: string) => {
          console.log(`[Mixpanel Identify] ID: ${id}`);
        },
        track: (eventName: string, properties?: Dict) => {
          console.log(`[Mixpanel Track] Event: ${eventName}`, properties);
        },
      };

class MixpanelService {
  identify(id: string) {
    mixpanel.identify(id);
  }

  track(eventName: string, properties?: Dict) {
    mixpanel.track(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
    });
  }
}

export const Mixpanel = new MixpanelService();
